import React from 'react';

export default class Currency extends React.PureComponent
{
    render() {
        return <span>{ this.props.children } руб.</span>
    }
}
